import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-tela-conteudo ss-alinhar-texto-esquerda" }
const _hoisted_5 = { class: "ss-card ss-card-space" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA")
], -1)
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Período:", -1)
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Status:", -1)
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Detalhes:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Baixar Arquivo", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Gerar Novo Arquivo", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Gerar Arquivo", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "Período:", -1)
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "Status:", -1)
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "Detalhes:", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { style: {"white-space":"pre-line"} }, "Baixar Arquivo", -1)
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_card = _resolveComponent("card")!
  const _component_dados_contabilista = _resolveComponent("dados-contabilista")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_selecionar_finalidade_arquivo = _resolveComponent("selecionar-finalidade-arquivo")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: _ctx.telaBase.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: false,
          empresasSelecionadas: [_ctx.state.codigoEmpresa]
        }, null, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_select, {
                  value: _ctx.state.codigoEmpresa,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.codigoEmpresa) = $event)),
                  options: _ctx.telaBase.empresasDisponiveis,
                  style: {"width":"100%"},
                  optionFilterProp: "label"
                }, null, 8, ["value", "options"])
              ])
            ], 512), [
              [_vShow, _ctx.telaBase.apresentarEmpresas]
            ]),
            ((_ctx.state.arquivoVisualizacao.codigo > 0))
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 'AFS' + _ctx.state.arquivoVisualizacao.codigo,
                  titulo: 'Arquivo: ' + _ctx.state.arquivoVisualizacao.nome
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.state.arquivoVisualizacao.dataInicial)) + " a " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.state.arquivoVisualizacao.dataFinal)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        (_ctx.state.arquivoVisualizacao.status === _ctx.EStatusArquivoFiscal.Falha)
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 0,
                              color: "error"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Falha")
                              ]),
                              _: 1
                            }))
                          : (_ctx.state.arquivoVisualizacao.status === _ctx.EStatusArquivoFiscal.Processando)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 1,
                                color: "processing"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Processando")
                                ]),
                                _: 1
                              }))
                            : (_ctx.state.arquivoVisualizacao.status === _ctx.EStatusArquivoFiscal.Concluido)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 2,
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Concluído")
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.state.arquivoVisualizacao.status === _ctx.EStatusArquivoFiscal.Excluido)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 3,
                                    color: "warning"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Excluído")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _hoisted_16,
                        _createElementVNode("span", {
                          style: {"white-space":"pre-line"},
                          innerHTML: _ctx.state.arquivoVisualizacao.auditoria
                        }, null, 8, _hoisted_17)
                      ])
                    ]),
                    (_ctx.state.arquivoVisualizacao.status === _ctx.EStatusArquivoFiscal.Concluido)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "ant-btn ant-btn-primary ss-tamanho-completo",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.baixarArquivo(_ctx.state.arquivoVisualizacao.link)))
                        }, _hoisted_19))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gerarNovoArquivo()))
                    }, _hoisted_21)
                  ]),
                  _: 1
                }, 8, ["titulo"]))
              : (_openBlock(), _createBlock(_component_a_collapse, {
                  key: 1,
                  class: "ss-accordion",
                  activeKey: _ctx.state.abaSelecionada,
                  "onUpdate:activeKey": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.abaSelecionada) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, {
                      key: "1",
                      header: "DADOS CONTADOR"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.state.apresentarDados)
                          ? (_openBlock(), _createBlock(_component_dados_contabilista, {
                              key: 0,
                              empresa: _ctx.state.codigoEmpresa,
                              contabilista: _ctx.state.contabilista,
                              "onUpdate:contabilista": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.contabilista) = $event))
                            }, null, 8, ["empresa", "contabilista"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_collapse_panel, {
                      key: "2",
                      header: "INFORMAÇÕES PARA GERAR O ARQUIVO"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_spin, {
                          spinning: _ctx.state.gerandoArquivo
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form, { layout: "vertical" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Arquivo",
                                      class: "ss-margin-campos",
                                      rules: [{ required: true }]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_finalidade_arquivo, {
                                          valor: _ctx.state.parametrosEscrituracaoDigital.codigoFinalidade,
                                          "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.parametrosEscrituracaoDigital.codigoFinalidade) = $event)),
                                          "radio-button": true
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Data Inicial e Final",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_data_inicial_final, {
                                          dataInicialSelecionada: _ctx.state.parametrosEscrituracaoDigital.dataInicial,
                                          "onUpdate:dataInicialSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.parametrosEscrituracaoDigital.dataInicial) = $event)),
                                          dataFinalSelecionada: _ctx.state.parametrosEscrituracaoDigital.dataFinal,
                                          "onUpdate:dataFinalSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.parametrosEscrituracaoDigital.dataFinal) = $event))
                                        }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ant-btn ant-btn-primary ss-tamanho-completo",
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gerarArquivo()))
                                        }, _hoisted_27)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["spinning"])
                      ]),
                      _: 1
                    }),
                    ((_ctx.state.arquivosFiscais.length > 0))
                      ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                          key: "3",
                          header: "HISTÓRICO DE ARQUIVOS"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.arquivosFiscais, (arquivoFiscal) => {
                              return (_openBlock(), _createBlock(_component_card, {
                                key: 'AF' + arquivoFiscal.codigo,
                                titulo: 'Arquivo: ' + arquivoFiscal.nome
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _hoisted_30,
                                      _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(arquivoFiscal.dataInicial)) + " a " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(arquivoFiscal.dataFinal)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                      _hoisted_32,
                                      (arquivoFiscal.status === _ctx.EStatusArquivoFiscal.Falha)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "error"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Falha")
                                            ]),
                                            _: 1
                                          }))
                                        : (arquivoFiscal.status === _ctx.EStatusArquivoFiscal.Processando)
                                          ? (_openBlock(), _createBlock(_component_a_tag, {
                                              key: 1,
                                              color: "processing"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Processando")
                                              ]),
                                              _: 1
                                            }))
                                          : (arquivoFiscal.status === _ctx.EStatusArquivoFiscal.Concluido)
                                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                                key: 2,
                                                color: "success"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Concluído")
                                                ]),
                                                _: 1
                                              }))
                                            : (arquivoFiscal.status === _ctx.EStatusArquivoFiscal.Excluido)
                                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                                  key: 3,
                                                  color: "warning"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Excluído")
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _hoisted_34,
                                      _hoisted_35,
                                      _createElementVNode("span", {
                                        style: {"white-space":"pre-line"},
                                        innerHTML: arquivoFiscal.auditoria
                                      }, null, 8, _hoisted_36)
                                    ])
                                  ]),
                                  (arquivoFiscal.status === _ctx.EStatusArquivoFiscal.Concluido)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "ant-btn ant-btn-primary ss-tamanho-completo",
                                        onClick: ($event: any) => (_ctx.baixarArquivo(arquivoFiscal.link))
                                      }, _hoisted_39, 8, _hoisted_37))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["titulo"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["activeKey"]))
          ])
        ])
      ])
    ])
  ]))
}